// 사용 예 : $t('filter.exportable')

export default {
  'filter': {
    'priority': '인기순',
    'release': '최신 등록순',
    'priceHigh': '높은 가격순',
    'priceLow': '낮은 가격순',
    'category': '카테고리',
    'releasedCountry': '출시지역',
    'licensee': '라이선시',
    'soundLang': '사운드 언어',
    'exportable': '구매 가능 여부',
    'resetFilter': '필터 초기화',
    'applyFilter': '필터 적용',
    'setFilter': '필터 설정',
    'closeFilter': '필터 닫기'
  },
  'newLP': {
    'addCart': '견적 요청하기',
    'alreadyAdded': '추가 완료',
    'category': '카테고리',
    'licensee': '라이선시',
    'sound': '사운드 언어',
    'year': '출시년도',
    'exportable': '구매 가능 여부',
    'canExport': '구매 가능',
    'cannotExport': '구매 불가',
    'releasedCountry': '출시지역',
    'maker': '라이선시',
    'price': '소비자가격',
    'options': '옵션 정보',
    'selectOption': '옵션 선택하기',
    'notExistsOption': '옵션 없음',
    'noOptions': '옵션을 선택해 주세요.',
    'release': '출시',
    'more': '더 보기',
    'closeMore': '닫기',
    'emptyList': '찾으시는 정보가 없습니다.'
  },
  'newCartPage': {
    'title': '견적 요청할 상품',
    'description': '견적 요청서 확인 후 요청서에 적어주신 이메일 주소로 안내드리겠습니다.\n특정 품목의 경우 거래가 제한 될 수 있습니다.',
    'submitOrder': '견적 요청하기',
    'removeAll': '모두 제거',
    'quantity': '견적 요청 수량',
    'request': '요청 사항',
    'quantityWarningTitle': '견적 요청 수량을 제대로 입력해 주세요.',
    'quantityWarningDescription': '견적 요청 수량이 비어있거나, 최소 주문 수량 미만인 상품이 있습니다.',
    'quantityWarningField': '0 보다 큰 정수를 입력',
    'quantityWarningFieldMOQ': '최소 주문 수량 이상 입력해 주세요.',
    'MOQ': '최소 주문 수량',
    'company': '업체명',
    'manager': '담당자',
    'email': '이메일',
    'contact': '연락처',
    'orderList': '견적 요청 목록',
    'orderProduct': '견적 요청 제품',
    'orderQuantity': '견적 요청 수량',
    'orderRequest': '비고',
    'agreeMessage': '개인정보 수집에 동의합니다.',
    'orderTitle': '견적요청서',
    'orderSubtitle': '견적 요청서 확인 후 아래에 적어주신 이메일 주소로 안내드리겠습니다.\n특정 품목의 경우 거래가 제한 될 수 있습니다.',
    'orderFieldError': '항목을 제대로 입력해 주세요.',
    'orderFieldErrorRequired': '필수 입력 항목입니다.',
    'orderFieldErrorEmail': '이메일 형식이 아닙니다.',
    'orderCreating': '견적요청서 생성 중',
    'orderCreateDone': '견적요청서 생성 완료!',
    'orderLoading': '견적요청서 보내는 중',
    'orderFailed': '견적요청서 전달 실패',
    'orderSuccess': '견적요청서 전달 성공',
    'removeAllConfirm': '전체 목록을 삭제 하시겠습니까?',
    'emptyList': '담긴 상품이 없습니다.',
    'removeAllDone': '전체 삭제 완료!',
    'close': '취소',
    'ok': '확인',
    'saleRegion': '판매 지역'
  },
  'message': {
    'viewSelctedItems': '모두보기',
    'clear': '비우기',
    'downloadPDF': 'PDF 다운로드',
    'all': '전체',
    'allSelected': '전체 선택',
    'allUnSelected': '전체 해제',
    'selected': '제품 선택',
    'unSelected': '선택 해제',
    'selectedItem': '선택 제품',
    'searchResults': '검색된 제품',
    'downloading': '다운로드 중입니다..'
  },
  'variables': {
    'homeMessage': "<p>핑크퐁 카탈로그 페이지에 오신 것을 환영합니다.</p><p>본 카탈로그는 B2B 업무 협력을 위한 제품 정보로, 공급가 및 최소주문수량 (MOQ) 등의 조건은 업무 커뮤니케이션을 통해 제공합니다.<br>제품 콘텐츠 유통에 관한 문의는 회사소개, 제안서, 취급 품목 등과 함께 아래의 링크에서 문의 등록을 바랍니다.<br><b><a target='_blank' href='https://bizhelp.pinkfong.com/hc/ko'>문의등록 바로가기</a></b></p>",
    'homeItem': [
      {
        'title': '핑크퐁 제품',
        'image': 'https://fs.smartstudy.co.kr/catalog/images/main-products.png',
        'link': '/ko/pinkfongproducts/all'
      },
      {
        'title': '핑크퐁 라이선스',
        'image': 'https://fs.smartstudy.co.kr/catalog/images/main-licensed.png',
        'link': '/ko/licensedproducts/all'
      },
      {
        'title': '핑크퐁 영상 콘텐츠',
        'image': 'https://fs.smartstudy.co.kr/catalog/images/main-video.png',
        'link': '/ko/mediacontent/all'
      }
    ],
    'LicensedProducts': '핑크퐁 라이선스 상품',
    'PinkfongProducts': '핑크퐁 제품',
    'MediaContent': '핑크퐁 영상 콘텐츠',
    'licensedproducts': '핑크퐁 라이선스 상품',
    'pinkfongproducts': '핑크퐁 제품',
    'mediacontent': '핑크퐁 영상 콘텐츠',
    'age': '사용 연령',
    'manufacturer': '제조원',
    'category': '카테고리',
    'price': '권장소비자가격',
    'currencyCode': '₩',
    'productDescription': '제품 소개',
    'productSize': '제품 규격',
    'weight': '무게',
    'productMaterial': '재질',
    'productPackageType': '포장 형태',
    'productBattery': '배터리 정보',
    'productReleaseDate': '출시일',
    'productBarcode': '바코드',
    'boxSize': '박스 규격',
    'boxWeight': '박스 무게',
    'boxQuantity': '박스당 수량',
    'is_discontinued': '단종 여부',
    'is_discontinued_true': '단종',
    'is_discontinued_false': '판매중',
    'em_code': '전자파인증 코드',
    'contentLanguage': '제작 언어',
    'seriesKnitting': '콘텐츠 수',
    'contentQuantity': '콘텐츠',
    'spec': '영상정보',
    'episodes': '에피소드',
    'onlyEnglishAge': '',
    'footerLinks': [
      {
        'name': '핑크퐁 공식 웹사이트',
        'link': 'https://www.pinkfong.com/?utm_source=catalog&utm_medium=footer'
      },
      {
        'name': '핑크퐁스토어',
        'link': 'https://store.pinkfong.com/?utm_source=catalog'
      },
      {
        'name': 'Instagram',
        'link': 'https://www.instagram.com/pinkfong.ko/'
      },
      {
        'name': 'Facebook',
        'link': 'https://www.facebook.com/pinkfong.ko/'
      },
      {
        'name': 'YouTube',
        'link': 'https://www.youtube.com/user/pinkfongko'
      }
    ],
    'metaList': [
      { name: 'robots', content: 'index,follow' },
      { name: 'description', content: '핑크퐁 제품, 라이선스 상품, 영상 콘텐츠에 대한 B2B 정보를 제공합니다.' },
      { name: 'auth', content: '핑크퐁' },
      { name: 'keywords', content: '핑크퐁 카탈로그, 핑크퐁 쇼룸, 핑크퐁 제품, 핑크퐁 라이선스, 핑크퐁 영상콘텐츠, 핑크퐁 콘텐츠' },
      { vmid: 'og:title', property: 'og:title', content: '핑크퐁 B2B 카탈로그' },
      { vmid: 'og:description', property: 'og:description', content: '핑크퐁 제품, 라이선스 상품, 영상 콘텐츠에 대한 B2B 정보를 제공합니다.' },
      { vmid: 'og:image', property: 'og:image', content: 'https://www.pinkfong.com/assets/img/sns.png' }
    ],
    'viewDetail': '자세히 보기',
    'relatedProducts': '이 상품과 연관된 상품'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/ko.js